import { CommonModule, DatePipe } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { CoilSheet, CoilSheetDataSets } from '../../shared/entities/coilSheet';
import { ExportData } from '../../shared/entities/export';
import { ExportService } from '../../shared/services/export.service';
import { min, Subscription } from 'rxjs';
import { EventEmitterService } from '../../shared/services/event-emitter.service';
import { MeasurementsDataService } from '../../shared/services/measurements-data.service';
import { Utility } from '../../shared/entities/utils';
import { ToastrService } from 'ngx-toastr';
import { ApexAxisChartSeries, ApexChart, ApexXAxis, ApexDataLabels, ApexYAxis, ApexFill, ApexStroke, ApexMarkers, NgApexchartsModule, ChartComponent, ApexTitleSubtitle, ApexAnnotations, ApexGrid, ApexPlotOptions, ApexTooltip, ApexLegend } from 'ng-apexcharts';
import { AgGridModule } from 'ag-grid-angular';
import { ChartModule } from 'primeng/chart';
import { SplitterModule } from 'primeng/splitter';
import { DropdownButtonComponent } from '../dropdown-button/dropdown-button.component';


export type ChartOptionsDefect = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  fill: ApexFill;
  legend: ApexLegend;
  xaxis: ApexXAxis;
  plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-defect-dialog',
  standalone: true,
  imports: [
    ButtonModule,
    DialogModule,
    FormsModule,
    AgGridModule,
    CommonModule,
    SplitterModule,
    ChartModule,
    NgApexchartsModule,
    ButtonModule,
    DialogModule,
    FormsModule,
    DropdownButtonComponent
  ],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './defect-dialog.component.html',
  styleUrl: './defect-dialog.component.scss'
})
export class DefectDialogComponent {
  regionUnit: string = '';
  @ViewChild("chart", { static: false }) chart: ChartComponent | any;
  public chartOptionsDefect!: Partial<ChartOptionsDefect> | any;
  constructor(
    private toastr: ToastrService,
    private exportService: ExportService,
    private datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private eventEmitterService: EventEmitterService,
    private measurementsDataService: MeasurementsDataService) {

    this.chartOptionsDefect = {
      series: [
        {
          name: "Top Defect",
          data: [
            {
              x: "Film Splice (Top 21m)",
              y: [
                1,
                10
              ]
            },
            {
              x: "Loose Film (Top 1m)",
              y: [
                22, 22
              ]
            },
            {
              x: "Loose Film (Top 1m)",
              y: [
                40, 50
              ]
            },
            {
              x: "Staining (Top 1m)",
              y: [
                80, 90
              ]
            },
            {
              x: "Staining (Top 1m)",
              y: [
                110, 140
              ]
            },
            {
              x: "Bug on Strip (Top 4m)",
              y: [
                150, 200
              ]
            },
            {
              x: "Splices TOP (68m) (NM)",
              y: [
                200, 250
              ]
            }
          ]
        },
        {
          name: "Bottom Defect",
          data: [
            {
              x: "Hole in Film (Bottom 1m)",
              y: [
                30, 40
              ]
            },
            {
              x: "Film Splice (Bottom 5m)",
              y: [
                50, 60
              ]
            },
            {
              x: "Splices BOTTOM (9m) (NM)",
              y: [
                70, 80
              ]
            },
            {
              x: "Laser Weld (NM)",
              y: [
                110, 130
              ]
            },
            {
              x: "Laser Weld (NM)",
              y: [
                140, 200
              ]
            }
          ]
        },
        {
          name: "Both Defect",
          data: [
            {
              x: "Weld BOTH (1m) (NM)",
              y: [
                20, 30
              ]
            },
            {
              x: "Not coated TS/OS (1m) (NM)",
              y: [
                5, 10
              ]
            }
          ]
        }
      ],
      chart: {
        height: 450,
        type: "rangeBar"
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "80%"
        }
      },
      xaxis: {
        type: "numeric",
        title: {
          text: `Coil Length in m`,
        }
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "vertical",
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [50, 0, 200, 100]
        }
      },
      legend: {
        position: "top",
        horizontalAlign: "center"
      }
    };




  }




  @Input() showDefectDialog: boolean = false;
  @Output() displayChangedefect = new EventEmitter();



  ngOnInit(): void {
  }

  ngOnDestroy() {
  }






  onClose() {
    this.displayChangedefect.emit(false);
    this.showDefectDialog = false;
  }
}
